// Values are always in snake_case
// Naming convention is coming from PostHog's best practices: https://posthog.com/docs/product-analytics/best-practices

export const EVENT_CATEGORIES = {
  SERVER: 'server',
  SIMULATION: 'simulation',
  SUBSCRIPTION: 'subscription', // registration flow, but is called "subscription" in all events
  EXTRA_ADDRESS: 'extra_address',
  CONTACT_US: 'contact_us',
  COMPLAINT: 'complaint',
  REFERRAL: 'referral'
} as const

export const EVENT_ACTIONS = {
  ADD: 'add',
  CATCH: 'catch',
  CANCEL: 'cancel',
  CLICK: 'click',
  COPY: 'copy',
  CREATE: 'create',
  CONFIRM: 'confirm',
  DELETE: 'delete',
  END: 'end',
  FAIL: 'fail',
  FINISH: 'finish',
  GENERATE: 'generate',
  INVITE: 'invite',
  REMOVE: 'remove',
  SEND: 'send',
  START: 'start',
  SUBMIT: 'submit',
  UPDATE: 'update',
  VIEW: 'view'
} as const

export const FEATURE_FLAGS = {
  simulationCardHeadline: 'simulation-card-headline',
  recommendedProductText: 'recommended-product-text',
  knowsEanLabelText: 'knows-ean-label-text',
  googleReviews: 'social-proof-reviews-google',
  injectionRoiSimulation: 'injection-roi-simulation-custom-usage',
  noEanMessage: 'no-ean-message'
} as const

// Possible variant values per flag — used by the dev overlay to render a select instead of a free-text input.
// Update this when you add or change variants in PostHog.
export const FEATURE_FLAG_VARIANTS: Partial<Record<(typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS], string[]>> = {
  [FEATURE_FLAGS.recommendedProductText]: ['control', 'test'],
  [FEATURE_FLAGS.simulationCardHeadline]: ['control', 'test'],
  [FEATURE_FLAGS.knowsEanLabelText]: ['control', 'test'],
  [FEATURE_FLAGS.googleReviews]: ['control', 'google'],
  [FEATURE_FLAGS.injectionRoiSimulation]: ['control', 'with-roi'],
  [FEATURE_FLAGS.noEanMessage]: ['control', 'no-ean-message']
} as const
